import type { Capability, Me } from '@wo/shared';

/**
 * Show a control only if the signed-in user holds the capability (roles are a setting). This
 * only hides buttons — the API checks the same capability on every request.
 */
export const can = (me: Pick<Me, 'caps'> | null | undefined, ...anyOf: Capability[]): boolean => anyOf.some((c) => me?.caps?.includes(c) ?? false);
